<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          v-if="admin || superAdmin"
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <breadcrumbs
          v-else-if="qAdmin"
          :items="breadcrumbsItems1"
      ></breadcrumbs>
      <breadcrumbs
          v-else
          :items="breadcrumbsItems2"
      ></breadcrumbs>
      <v-card class="ma-3" outlined>
        <v-flex
            class="pa-2 mt-0 ml-4"
        >
          <v-row class="ma-1">
            <v-card-title class="pl-0">{{ queue.name }}</v-card-title>
            <v-card-text class="pl-0" style="font-size: smaller;font-weight: lighter">
              {{ queue.description }}
            </v-card-text>
          </v-row>
          <v-row
              v-if="qAdmin || admin || superAdmin"
              class="ma-1"
          >
            <v-btn @click="edit(queue)" class="ma-2">Edit</v-btn>
            <v-btn @click="show('admin')" class="ma-2">Queue</v-btn>
            <v-btn @click="show('monitor')" class="ma-2">Monitor</v-btn>
            <v-btn @click="show('record')" class="ma-2">Report</v-btn>
            <v-btn @click="show('appointment')" class="ma-2">Appointment</v-btn>
            <v-btn dark @click="deleteQ(queue)" class="ma-2" color="red">Delete</v-btn>
          </v-row>
          <v-divider></v-divider>
          <!-- Book Appointment -->
          <queue-monitor
              v-if="show_monitor"
              :outlet="outlet"
              :queue="queue"
              :services="services"
              :user="user"
          ></queue-monitor>
          <record
              v-if="show_record"
              :outlet="outlet"
              :queue="queue"
          ></record>
          <queue-admin
              v-if="show_admin"
              :outlet="outlet"
              :queue="queue"
          ></queue-admin>
          <queue-appointment
              v-if="((qAdmin || admin || superAdmin) && show_appointment) || !(qAdmin || admin || superAdmin)"
              :outlet="outlet"
              :queue="queue"
              :user="user"
              :operation_times="operation_times"
              :operation_dow="operation_dow"
              :services="services"
          ></queue-appointment>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  name: 'queue',
  data: () => {
    return {
      breadcrumbsItems: '',
      breadcrumbsItems1: '',
      breadcrumbsItems2: '',
      appointmentTime: '',
      show_monitor: false,
      show_record: false,
      show_admin: false,
      show_appointment: false,
    }
  },
  computed: {
    admin() {
      let isAdmin = this.user.role_id === 2 || this.user.role_id === 4;
      let correctGroup = this.user.group_id === this.outlet.group_id;
      return isAdmin && correctGroup;
    },
    qAdmin() {
      let isAdmin = this.user.role_id === 5;
      let correctGroup = this.user.group_id === this.outlet.group_id;
      return isAdmin && correctGroup;
    },
    superAdmin() {
      return this.user.role_id === 1;
    },
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
  },
  props: ['outlet', 'queue', 'user', 'operation_times', 'operation_dow', 'services'],
  methods: {
    show(module) {
      switch (module) {
        case 'monitor':
          this.show_monitor = true;
          this.show_record = false;
          this.show_admin = false;
          this.show_appointment = false;
          break;
        case 'record':
          this.show_monitor = false;
          this.show_record = true;
          this.show_admin = false;
          this.show_appointment = false;
          break;
        case 'admin':
          this.show_monitor = false;
          this.show_record = false;
          this.show_admin = true;
          this.show_appointment = false;
          break;
        case 'appointment':
          this.show_monitor = false;
          this.show_record = false;
          this.show_admin = false;
          this.show_appointment = true;
          break;
      }
    },
    edit(q) {
      window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id + '/edit'
    },
    deleteQ(q) {
      if (confirm('Are you sure you want to delete this queue?')) {
        axios.delete('/outlet/' + this.outlet.id + '/queue/' + q.id + '/delete').then(response => {
          window.location.href = '/outlet/' + this.outlet.id + '/edit'
        });
      }
    },
  },
  beforeMount() {
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id,
        link: true,
        text: this.outlet.name + ' Queue List',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.queue.name,
      },
    ];
    this.breadcrumbsItems1 = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.queue.name,
      },
    ];
    // guest
    this.breadcrumbsItems2 = [
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/online',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: this.queue.name,
      },
    ];
  },
}
</script>

<!--<style>-->
<!--    .signup span.v-btn__content{-->
<!--        font-size: smaller!important;-->
<!--    }-->
<!--</style>-->



// WEBPACK FOOTER //
// resources/assets/js/components/Queues/Queue.vue